import React from 'react';
import { connect } from 'react-redux';
import { setUser } from 'app/api/analytics/reporting';
import { getUserProfile } from 'app/api/redux-jigsaw/user-info-selectors';

class ReporterContext extends React.Component {
  componentDidMount() {
    this.updateContext();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.jigsawUser !== prevProps.jigsawUser) {
      this.updateContext();
    }
  }

  updateContext() {
    setUser(this.props.jigsawUser);
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  jigsawUser: getUserProfile(state),
});

export default connect(mapStateToProps)(ReporterContext);



// WEBPACK FOOTER //
// ./src/app/ui/analytics/ReporterContext.js